<app-csv-import-shell [host]="this">
    <div csvImportToolbarExtra class="flex items-center">
        @if (!hasQuantityColumnMapped()) {
            <phx-checkbox [ngModel]="importDefaultQuantityOneSettingSig()" (inlineChange)="importDefaultQuantityOneSettingSig.set($event)">
                {{ 'document-line-item.csv-import.default-quantity-one' | translate }}
            </phx-checkbox>
        }
    </div>

    <div csvImportFooterExtra>
        @if (importFinished() && deferredImportCount() > 0) {
            <div
                class="flex items-center gap-2 p-3 bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800 rounded-md text-amber-800 dark:text-amber-200"
            >
                <i class="fa fa-exclamation-triangle text-amber-600 dark:text-amber-400"></i>
                <span>{{
                    'document-line-item.csv-import.reservation-deferred-summary'
                        | translate: { count: deferredImportCount() }
                }}</span>
            </div>
        }
    </div>
</app-csv-import-shell>
